var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonalDataIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    width: 33,
    height: 33,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8337 10.7498C19.8337 12.5908 18.3413 14.0832 16.5003 14.0832C14.6594 14.0832 13.167 12.5908 13.167 10.7498C13.167 8.90889 14.6594 7.4165 16.5003 7.4165C18.3413 7.4165 19.8337 8.90889 19.8337 10.7498Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6668 21.7705C23.6668 23.0047 23.64 23.8236 22.8928 24.4321C22.4999 24.752 21.8682 25.0445 20.8333 25.254C19.8005 25.4631 18.3996 25.583 16.5002 25.583C14.6007 25.583 13.1998 25.4631 12.1671 25.254C11.1321 25.0445 10.5004 24.752 10.1076 24.4321C9.36037 23.8236 9.3335 23.0047 9.3335 21.7705C9.3335 20.8407 10.009 19.8969 11.3242 19.157C12.6238 18.426 14.4528 17.958 16.5002 17.958C18.5475 17.958 20.3765 18.426 21.6761 19.157C22.9914 19.8969 23.6668 20.8407 23.6668 21.7705Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDataIcon);
export default __webpack_public_path__ + "static/media/personalDataIcon.67dcda6432c41ff01ba07b1a628aa1e6.svg";
export { ForwardRef as ReactComponent };